<div class="card card-custom">
  <div class="card-header">
    <div class="d-flex align-items-center justify-content-end">
      <button
        mat-raised-button
        matTooltip="{{'GLOBAL.CLOSE' | translate}}"
        class="btn btn-icon btn-light"
        (click)="closeDialog()"
      >
        <span
          inlineSVG="assets/media/svg/icons/Navigation/Close.svg"
          class="svg-icon svg-icon-lg"
        ></span>
      </button>
    </div>
  </div>
  <div class="card-body">
    <ngx-extended-pdf-viewer
      [src]="data.url"
      [height]="'90vh'"
      [textLayer]="true"
      [showUnverifiedSignatures]="true"
      [showHandToolButton]="true"
    >
    </ngx-extended-pdf-viewer>
  </div>
</div>
